import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
 root: {
    padding: 24,
    maxWidth: 600,
    margin: '0 auto',
    backgroundColor: '#ffffff',
    borderRadius: 4,
    boxShadow: theme.customShadows.widget,
    paddingTop: theme.spacing(5),
  },
  header: {
    marginBottom: 30,
  },
  card: {
    border: '1px solid #0000003B',
    borderRadius: 4,
    padding: '19px 22px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: 'none',
  },
  cardPhoneNumber: {
    marginBottom: '10px',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  iconBox: {
    marginRight: theme.spacing(2),
    marginTop: 4,
    color: '#5A5959',
  },
  contentBody: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 20,
  },
  changeBtn: {
    color: '#008EA9',
    textTransform: 'none',
    fontSize: '12px',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
    '&.MuiButton-text': {
        padding: 0,
    },
  },
  editIcon: {
    fontSize: 20,

  },
  subTitle: {
    color: '#5A5959',
  },
  subValue: {
    color: '#A6A6A6',
    marginTop: theme.spacing(0.5),
    minWidth: '100px'
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
  },
  statusText: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(3),
    fontWeight: 500,
  },
  statusIcon: {
    marginRight: theme.spacing(1),
    fontSize: '1.2rem',
  },
  verifyBtn: {
    color: '#008EA9',
    borderRadius: 4,
    border: '1px solid #008EA9',
    fontWeight: 500,
    
    padding: '6px 18px',
  },

});

export default styles;
export const useStyles = makeStyles(styles);
